import React from 'react';
import BaseComponent from '../../components/system/base';

class LosePopup extends BaseComponent {

  render() {
    let calculateQuantityLeftOnPunchCard = 5;
    return (
     <React.Fragment>
        <span>
          <div style={{paddingTop: 20}}>
            <div style={{width: 300, height: 181, paddingBottom: 40, backgroundRepeat: "no-repeat", backgroundImage: "url('/images/content/losePopup/fishLose.png')"}}>
              {this.lang == "en" && <div style={{fontSize: 18, color: "#1691CF", paddingTop: 11, paddingLeft: 24}}>Sorry, you did not<br/>win a prize.</div>}
              {this.lang == "jp" && <div style={{fontSize: 18, color: "#1691CF", paddingTop: 11, paddingLeft: 24}}>Chihiro todo...</div>}
              {this.lang == "en" && <div style={{fontSize: 12, color: "white", paddingTop: 3, paddingLeft: 120}}>I held my breath and obtained<br/>a special raffle ticket power,<br/>for you to win a trip to <br/><strong>Disneyland!</strong></div>}
              {this.lang == "jp" && <div style={{fontSize: 12, color: "white", paddingTop: 3, paddingLeft: 120}}>Chihiro todo....</div>}
            </div>
          </div>
          <div style={{paddingBottom: 30}}>
            <div style={{width: 305, height: 142, backgroundRepeat: "no-repeat", backgroundImage: "url('/images/content/losePopup/myWinningsLose.png')"}}>
              <div style={{fontSize: 15, color: "white", paddingTop: 9, paddingLeft: 84}}>{this.globs.__(this.translate["oneVisitCloser"], {dayCount: this.props.punchCard.Quantity - calculateQuantityLeftOnPunchCard})}:</div>
              <div style={{fontSize: 21, paddingLeft: 141, paddingTop: 12}} className="pink">{
                this.lang == "en" ? this.props.punchCard.Title : this.props.punchCard.TitleJP
              }</div>
              <img style={{width: 141, marginLeft: 141, marginTop: 6}} src={"/images/content/winningPopup/" + this.props.punchCard.Category + ".png"} alt={"Category "+ this.props.punchCard.Category}/>
            </div>
          </div>
        </span>
      </React.Fragment>
    );
  }
}

LosePopup.propTypes = {
  // productNameWon : PropTypes.string,
};

export default LosePopup


// WEBPACK FOOTER //
// ./src/content/winPrize/losePopup.js